import { CombinationTable } from 'components/table/combination_rule/CombinationTable';

const Combinations = () => {
    return ( <CombinationTable/> )
}

export { Combinations }